var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.644.335H1.355C.607.335 0 .932 0 1.667 0 2.403.607 3 1.355 3h15.289c.748 0 1.355-.597 1.355-1.333 0-.735-.607-1.332-1.355-1.332z",
    fill: "#000"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTggMyIgZmlsbD0iI2ZmZmZmZiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjY0MzcgMC4zMzQ5NjFIMS4zNTUxM0MwLjYwNzA5NiAwLjMzNDk2MSAwIDAuOTMxOTI2IDAgMS42Njc0N0MwIDIuNDAzMDIgMC42MDcwOTYgMi45OTk5OSAxLjM1NTEzIDIuOTk5OTlIMTYuNjQzN0MxNy4zOTE3IDIuOTk5OTkgMTcuOTk4OCAyLjQwMzAyIDE3Ljk5ODggMS42Njc0N0MxNy45OTg4IDAuOTMxOTI2IDE3LjM5MTcgMC4zMzQ5NjEgMTYuNjQzNyAwLjMzNDk2MVoiIGZpbGw9IiNmZmZmZmYiIC8+Cjwvc3ZnPgo=";
export { SvgDownloadBar as ReactComponent };